import { render, staticRenderFns } from "./MarkdownRenderer.vue?vue&type=template&id=532ff2b2"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=js"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=js"
import style0 from "./MarkdownRenderer.vue?vue&type=style&index=0&id=532ff2b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports